<template>
  <SkeletonTheme color="#E9EDF3" highlight="#F7F9FA">
    <div class="single-setting-wrapper">
      <Skeleton :circle="true" height="30px" width="30px"></Skeleton>
      <div v-if="title" class="setting-title">
        <div>
          <Skeleton width="136px"></Skeleton>
        </div>
      </div>
      <div class="slot column">
        <Skeleton width="347px"></Skeleton>
        <Skeleton width="347px"></Skeleton>
        <Skeleton height="40px" width="161px"></Skeleton>
        <slot></slot>
      </div>
    </div>
  </SkeletonTheme>
</template>

<script>
import { Skeleton, SkeletonTheme } from 'vue-loading-skeleton'

export default {
  components: {
    Skeleton,
    SkeletonTheme,
  },
  props: {
    title: String,
    description: String,
    name: String,
  },
}
</script>

<style lang="scss" scoped>
.single-setting-wrapper {
  .setting-title {
    position: relative;
    div {
      @include font-rule('averta-bold');
      font-size: 16px;
      line-height: 15px;
      letter-spacing: 0.3px;
    }
  }

  .setting-description {
    @include font-rule('averta-regular');
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.3px;
    color: #9093c0;
    margin-top: 3px;
    margin-bottom: 0;
  }
}

@include respond-above(sm) {
  .single-setting-wrapper {
    width: 550px;
    display: grid;
    grid-template-columns: 30px auto;
    column-gap: 20px;
    grid-template-rows: auto auto 46px auto; // title description gap content
    //row-gap: 20px;
    .icon {
      grid-row: 1;
      grid-column: 1;
      width: 30px;
      height: 30px;
    }

    .setting-title {
      grid-row: 1;
      grid-column: 2;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .setting-description {
      grid-row: 2;
      grid-column: 2;
    }

    .slot {
      grid-row: 4;
      grid-column: 2;

      &.custom {
        // styling provided in the parent element
      }

      &.grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 8%;
        grid-auto-rows: auto;
        grid-row-gap: 30px;
      }
      &.column {
        display: flex;
        flex-direction: column;
        width: 220px;
        * {
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0;
            margin-top: 12px;
          }
        }
      }
    }
  }
}

@include respond-below(sm) {
  .single-setting-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start; // comment to center horizontally

    .icon {
      margin-bottom: 18px;
    }

    .setting-description {
      margin-top: 13.5px;
    }

    .slot.grid {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: initial;
    }
  }
}
</style>
